import { Component } from '@angular/core';

@Component({
  selector: 'cad-footer-private',
  templateUrl: './footer-private.component.html',
  styleUrls: ['./footer-private.component.scss'],
})
export class FooterPrivateComponent {}
